import { Component, Inject, Input } from '@angular/core';
import { User } from '../../../../module/user/types';
import { BehaviorSubject } from 'rxjs';
import { DIALOG_DATA, DialogService } from '../../../../services/dialog.service';
import { observe } from '../../../../shared/utils/common';
import { UsersService } from '../../../../services/users.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'admin-users-send-welcome-email-dialog',
  template: `
    <fieldmagic-dialog
      label="Send Welcome Email"
      icon="envelope-open-text"
      [instance]="self"
    >
      <ng-template fieldmagicDialogButtonsTmp>
        <fieldmagic-primary-button
          label="Send"
          icon="envelope"
          (click)="onSend()"
          [isInProgress]="processing$ | async"
        >
        </fieldmagic-primary-button>
      </ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <fieldmagic-alert
          variant="info"
        >
          <fieldmagic-text
            content="{{ 'You are about to send a welcome email to %s. Please input the previously set password to include it in the email. Otherwise, leave the field blank if you wish not to include the password.' | translate | sprintf: [user.email_address] }}"
          >
          </fieldmagic-text>
        </fieldmagic-alert>
        <fieldmagic-text-input
          [standalone]="false"
          label="Previous Password"
          [(ngModel)]="password"
          [obsecure]="true"
        >
        </fieldmagic-text-input>
      </ng-template>
    </fieldmagic-dialog>
  `,
})
export class SendUserWelcomeEmailDialogComponent {
  password?: string;

  readonly processing$ = new BehaviorSubject<boolean>(false);

  get self(): SendUserWelcomeEmailDialogComponent {
    return this;
  }

  get user(): User {
    return this._data.user;
  }

  constructor(
    @Inject(DIALOG_DATA) private readonly _data: SendUserWelcomeEmailDialogData,
    private readonly _users: UsersService,
    private readonly _dialog: DialogService,
  ) {}

  onSend = () => observe({
    before: () => this.processing$.next(true),
    after: () => this.processing$.next(false),
    observable: () => this._users.sendWelcomeEmail(this.user.id, {
      known_password: this.password,
    }),
  }).pipe(
    filter((succeeded) => succeeded)
  ).subscribe((_) => {
    this._dialog.close({
      instance: this,
    });
  });
}

@Component({
  selector: 'admin-users-send-welcome-email-button',
  template: `
    <fieldmagic-primary-button
      purpose="icon"
      [icon]="[{
        icon: 'envelope-open-text',
        size: 'list-icon'
      }]"
      tooltip="Send welcome email"
      klass="p-0"
      [isInProgress]="processing$ | async"
      (click)="onClick()"
    ></fieldmagic-primary-button>
  `,
  providers: [
    DialogService,
  ],
})
export class SendUserWelcomeEmailButtonComponent {
  @Input() user: User;

  readonly processing$ = new BehaviorSubject<boolean>(false);

  constructor(
    private readonly _dialog: DialogService,
  ) {}

  onClick(): void {
    this.processing$.next(true);

    this._dialog.show({
      component: SendUserWelcomeEmailDialogComponent,
      data: {
        user: this.user,
      },
      afterClosing: (_) => this.processing$.next(false),
    });
  }
}

export type SendUserWelcomeEmailDialogData = {
  user: User;
}